<template> 
  <div class="wechatQr">
    <div class="tit">请打开微信扫一扫</div>
    <div class="qrBox">
      <img class="qrImg" :src="dataQr" />
    </div>
  </div>
</template>

<script>
import QRCode from 'qrcode'
import configs from '@/config/config'
export default {
  props: {
    id: String|Number,
    type: String,
    path: String
  },
  data(){
    return {
      dataQr: ''
    }
  },
  mounted() {
    this.initPage()
  },
  methods: {
    initPage() {
      this.getQr()
    },
    getQr() {
      let sharePath = process.env.NODE_ENV === 'production' ? shareUrl : configs.shareUrl
      if (this.type == 'photo') {
        sharePath += 'exhibit/' + this.id
      } else {
        sharePath += this.path.substr(1, this.path.length)
      }
      this.$emit('loaded', sharePath)

      QRCode.toDataURL(sharePath, {margin: 0}).then(url => {
        this.dataQr = url
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.wechatQr {
  .tit {
    background-color: #ebebeb;
    text-align: center;
    padding: 10px 0;
  }
  .qrBox {
    padding: 15px;
    .qrImg {
      display: block;
      width: 100%;
      height: 100%;
    }
  }
}
</style>